import { render } from "./NotAuthorised.vue?vue&type=template&id=71a4a5e2"
import script from "./NotAuthorised.vue?vue&type=script&lang=js"
export * from "./NotAuthorised.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__